import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";
import MaterialTable from "material-table";

// Reactstrap components
import { Button, Card, CardBody, FormGroup, Input, Row, Col } from "reactstrap";

// style
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// services
import { InputCEP } from "../../services/mask.js";
import { api_GET, api_POST } from "../../services/api_service.js";
import { showMessage } from "../../services/message.js";
import { GetCEPViaCEP } from "../../services/viaCep.js";

// views
import FichaTransportador from "../Shared/Transportador/FichaTransportador";
import FichaGerador from "../Shared/Gerador/FichaGerador";
import FichaDestino from "../Shared/Destino/FichaDestino";

//Context
import { useAuth } from "../../context/auth.js";

export default function ConsultaCadastro({ history }) {
  const { session, setLoading, setupSistema } = useAuth();

  const { register, errors, setValue, clearErrors, getValues } = useForm({
    mode: "onBlur",
  });

  const [listProtocolos, set_listProtocolos] = React.useState(null);
  const [protocolo, set_protocolo] = React.useState(null);
  // mostra campos de enderenço
  const [inputMostra, setInputMostra] = React.useState(false);

  // Segmento
  const [segmento, set_segmento] = React.useState("");
  const [options_segmento] = React.useState([
    { value: "Destino Final", label: "Destino Final" },
    { value: "Grande Gerador", label: "Grande Gerador" },
    { value: "Grande Gerador - PGRCC", label: "Grande Gerador - PGRCC" },
    { value: "Transportador", label: "Transportador" },
  ]);
  const handleSegmento = (value) => {
    set_segmento(value);
    setValue("segmento", value, true);
    clearErrors("segmento");
    loadOptionsCategoria(value);
    set_categoria(null);
  };

  // CEP
  const [cep, set_cep] = React.useState("");
  const handleCEP = (event) => {
    set_cep(event.target.value);

    if (event.target.value.replaceAll("_", "").length != 9) {
      setValue("logradouro", "");
      setValue("bairro", "");
      setValue("cidade", "");
      setValue("uf", "");
      return;
    }

    clearErrors("cep");

    GetCEPViaCEP(event.target.value).then((result) => {
      if (
        result.status !== 200 ||
        (result.data.hasOwnProperty("erro") && result.data.erro == true)
      ) {
        showMessage("Aviso", "Cep não localizado", "warning", null);
        setValue("logradouro", "");
        setValue("bairro", "");
      } else {
        setValue("logradouro", result.data.logradouro);
        setValue("bairro", result.data.bairro);
      }
    });
  };

  // Categoria
  const [categoria, set_categoria] = React.useState(null);
  const [options_categoria, set_options_categoria] = React.useState([]);
  const loadOptionsCategoria = (_segmento) => {
    api_GET(
      `Categoria/GetListByExistsSetupSolicitacaoByUsuario/${session.usuario_Id}`
    )
      .then((result) =>
        set_options_categoria(
          result.data.filter((f) => f.segmento === _segmento)
        )
      )
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };
  const handleCategoria = (value) => {
    set_categoria(value);
    setValue("categoria", value, true);
    clearErrors("categoria");
  };

  const handlePesquisar = () => {
    if (segmento === "") {
      showMessage("Aviso", "Informe o segmento!", "error", null);
      return;
    }

    if (categoria === "") {
      showMessage("Aviso", "Informe a categoria!", "error", null);
      return;
    }

    if (categoria === "RSS" && segmento !== "Grande Gerador") {
      showMessage(
        "Aviso",
        "Cadastro não disponível no sistema!",
        "error",
        null
      );
      return;
    }

    let data = getValues();

    if (
      data.cpf_cnpj.length === 0 &&
      data.codigoCadastro.length === 0 &&
      data.nomeResponsavel.length === 0 &&
      data.nomeFantasia.length === 0 &&
      data.razaoSocial.length === 0 &&
      data.cep === undefined &&
      data.logradouro === undefined &&
      data.bairro === undefined &&
      data.placa === undefined
    ) {
      showMessage("Aviso", "Informe ao menos um dos campos!", "error", null);
      return;
    }

    set_protocolo(null);
    setLoading(true);

    const json_submit = {
      cpfcnpj: data.cpf_cnpj.length === 0 ? "0" : data.cpf_cnpj,
      segmento: segmento,
      categoria_Id: categoria,
      codigoCadastro:
        data.codigoCadastro.length === 0 ? "0" : data.codigoCadastro,
      nomeResponsavel:
        data.nomeResponsavel.length === 0 ||
          data.nomeResponsavel.trimStart() === ""
          ? "0"
          : data.nomeResponsavel,
      nomeFantasia:
        data.nomeFantasia.length === 0 || data.nomeFantasia.trimStart() === ""
          ? "0"
          : data.nomeFantasia,
      razaoSocial:
        data.razaoSocial.length === 0 || data.razaoSocial.trimStart() === ""
          ? "0"
          : data.razaoSocial,
      cep:
        data.cep === undefined ||
          data.cep.length === 0 ||
          data.cep.trimStart() === ""
          ? "0"
          : data.cep,
      logradouro:
        data.logradouro === undefined ||
          data.logradouro.length === 0 ||
          data.logradouro.trimStart() === ""
          ? "0"
          : data.logradouro,
      bairro:
        data.bairro === undefined ||
          data.bairro.length === 0 ||
          data.bairro.trimStart() === ""
          ? "0"
          : data.bairro,
      numero:
        data.numero === undefined ||
          data.numero.length === 0 ||
          data.numero.trimStart() === ""
          ? "0"
          : data.numero,
      placa:
        data.placa === undefined ||
          data.placa.length === 0 ||
          data.placa.trimStart() === ""
          ? "0"
          : data.placa,
      exibirCancelados: data?.exibirCancelados ?? false
    };

    api_POST("protocolo/ByDocumento", json_submit)
      .then((result) => set_listProtocolos(result.data))
      .catch((err) => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };

  const handleColumnRazaoSocial = (rowData) => {
    if (
      rowData.protocoloTransportador &&
      rowData.protocoloTransportador.length > 0
    ) {
      return rowData.protocoloTransportador[0].nome_Fantasia;
    } else if (
      rowData.protocoloGerador &&
      rowData.protocoloGerador.length > 0
    ) {
      return rowData.protocoloGerador[0].nome_Fantasia;
    } else if (
      rowData.protocoloDestino &&
      rowData.protocoloDestino.length > 0
    ) {
      return rowData.protocoloDestino[0].nome_Fantasia;
    }
  };

  const handleColumnResponsavel = (rowData) => {
    if (
      rowData.protocoloTransportador &&
      rowData.protocoloTransportador.length > 0
    ) {
      return rowData.protocoloTransportador[0].nomeResponsavel;
    } else if (
      rowData.protocoloGerador &&
      rowData.protocoloGerador.length > 0
    ) {
      return rowData.protocoloGerador[0].nomeResponsavel;
    } else if (
      rowData.protocoloDestino &&
      rowData.protocoloDestino.length > 0
    ) {
      return rowData.protocoloDestino[0].nomeResponsavel;
    }
  };

  const montaEndereco = (endereco) => {
    if (!endereco) return "";
    const complemento = endereco.complemento
      ? ", " + endereco.complemento
      : "";
    return (
      endereco.logradouro +
      ", " +
      endereco.numEndereco +
      complemento +
      ", " +
      endereco.bairro
    );
  };

  const handleColumnEndereco = (rowData) => {
    if (
      rowData.protocoloTransportador &&
      rowData.protocoloTransportador.length > 0
    ) {
      return montaEndereco(rowData.protocoloTransportador[0]);
    } else if (
      rowData.protocoloGerador &&
      rowData.protocoloGerador.length > 0
    ) {
      return montaEndereco(rowData.protocoloGerador[0]);
    } else if (
      rowData.protocoloDestino &&
      rowData.protocoloDestino.length > 0
    ) {
      return montaEndereco(rowData.protocoloDestino[0]);
    }
  };

  const handleView = (rowData) => {
    set_protocolo(rowData);
  };

  return (
    <>
      <div className="content">
        <Card className="card-stats">
          <CardBody>
            <Row className="align-items-end">
              <Col md="3" lg="3">
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">*</span> Segmento
                    </label>
                  </b>
                  <Select
                    options={options_segmento}
                    name="segmento"
                    onChange={(e) => {
                      handleSegmento(e.value);
                    }}
                    value={
                      segmento != "" &&
                      options_segmento.find((obj) => obj.value === segmento)
                    }
                    placeholder="Selecione"
                    ref={(e) =>
                      register({ name: "segmento" }, { required: true })
                    }
                  />
                  {errors.segmento && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>
              <Col md="3" lg="3">
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">*</span> Categoria
                    </label>
                  </b>
                  <Select
                    options={options_categoria}
                    name="categoria"
                    getOptionLabel={(option) => option.descricao}
                    getOptionValue={(option) => option.categoria_Id}
                    onChange={(e) => {
                      handleCategoria(e.categoria_Id);
                    }}
                    value={
                      categoria != null &&
                      options_categoria.find(
                        (obj) => obj.categoria_Id === categoria
                      )
                    }
                    placeholder="Selecione"
                    ref={(e) =>
                      register({ name: "categoria" }, { required: true })
                    }
                  />
                  {errors.categoria && (
                    <span className="form-control-label text-danger">
                      * Campo Obrigatório
                    </span>
                  )}
                </FormGroup>
              </Col>
              <Col md="2">
                <FormGroup>
                  <b>
                    <label> CNPJ/CPF</label>
                  </b>
                  <Input
                    type="text"
                    maxLength="14"
                    name="cpf_cnpj"
                    innerRef={register({ required: false })}
                    defaultValue=""
                  />
                </FormGroup>
              </Col>
              <Col md={segmento != "Transportador" ? 4 : 2}>
                <FormGroup>
                  <b>
                    <label> Código do Cadastro</label>
                  </b>
                  <Input
                    type="text"
                    maxLength="14"
                    name="codigoCadastro"
                    innerRef={register({ required: false })}
                    defaultValue=""
                  />
                </FormGroup>
              </Col>
              {segmento === "Transportador" && (
                <Col md="2">
                  <FormGroup>
                    <b>
                      <label> Placa</label>
                    </b>
                    <Input
                      type="text"
                      maxLength="14"
                      name="placa"
                      innerRef={register({ required: false })}
                      defaultValue=""
                    />
                  </FormGroup>
                </Col>
              )}
              <Col md="4">
                <FormGroup>
                  <b>
                    <label> Nome Responsável</label>
                  </b>
                  <Input
                    type="text"
                    maxLength="50"
                    name="nomeResponsavel"
                    innerRef={register({ required: false })}
                    defaultValue=""
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <b>
                    <label> Nome Fantasia</label>
                  </b>
                  <Input
                    type="text"
                    maxLength="50"
                    name="nomeFantasia"
                    innerRef={register({ required: false })}
                    defaultValue=""
                  />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <b>
                    <label> Razão Social</label>
                  </b>
                  <Input
                    type="text"
                    maxLength="50"
                    name="razaoSocial"
                    innerRef={register({ required: false })}
                    defaultValue=""
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row className="align-items-end">
              {inputMostra && (
                <>
                  <Col md="2">
                    <FormGroup>
                      <b>
                        <label>CEP</label>
                      </b>
                      <InputCEP
                        type="text"
                        name="cep"
                        onChange={handleCEP}
                        value={cep}
                        inputRef={register({ required: true })}
                        defaultValue=""
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <b>
                        <label>Logradouro</label>
                      </b>
                      <Input
                        type="text"
                        name="logradouro"
                        innerRef={register({ required: false })}
                        defaultValue=""
                      />
                    </FormGroup>
                  </Col>
                  <Col md="2">
                    <FormGroup>
                      <b>
                        <label>Bairro</label>
                      </b>
                      <Input
                        type="text"
                        name="bairro"
                        innerRef={register({ required: false })}
                        defaultValue=""
                      />
                    </FormGroup>
                  </Col>
                  <Col md="2">
                    <FormGroup>
                      <b>
                        <label>Número</label>
                      </b>
                      <Input
                        type="number"
                        maxLength="10"
                        name="numero"
                        innerRef={register({ required: false })}
                        defaultValue=""
                      />
                    </FormGroup>
                  </Col>
                </>
              )}
            </Row>
            <Row>
              <Col md="2" className="mx-4">
                <FormGroup>
                  <Input
                    type="checkbox"
                    name="exibirCancelados"
                    innerRef={register()}
                    defaultChecked={false}
                  />
                  <b>
                    <label> Cadastros Cancelados</label>
                  </b>
                </FormGroup>
              </Col>
            </Row>
            <Row className="align-items-end">
              <Col md="2">
                <Button
                  color="primary"
                  className="btn-mobile"
                  type="button"
                  onClick={(_) => setInputMostra(!inputMostra)}
                >
                  <i className="fas fa-filter"></i> Filtros Avançados
                </Button>
              </Col>
              <Col md="3">
                <Button
                  color="success"
                  className="btn-mobile"
                  type="button"
                  onClick={handlePesquisar}
                >
                  <i className="fas fa-search"></i> Pesquisar
                </Button>
              </Col>
            </Row>

            {!protocolo && listProtocolos && listProtocolos.length > 0 && (
              <Row>
                <Col md="12" className="text-center mt-4">
                  {segmento === "Transportador" &&
                    listProtocolos.filter((f) => f.status == "Ativo").length >
                    0 &&
                    setupSistema &&
                    setupSistema.tipoCertificadoTransportador ==
                    "Unificado" && (
                      <div className="row">
                        <div className="col-12 col-lg-12 col-sm-12 text-center">
                          <h6>
                            Clique no QRCode abaixo para extrair o Certificado
                          </h6>
                          <i
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              window.open(
                                "/empty/CertificadoTransportadorUnificado?protocolo=" +
                                listProtocolos[0].numeroProtocolo,
                                "_blank"
                              )
                            }
                            className="fas fa-qrcode fa-2x"
                          ></i>
                        </div>
                      </div>
                    )}
                </Col>
                <Col md="12">
                  <MaterialTable
                    style={{ minHeight: "auto" }}
                    title=""
                    columns={[
                      { title: "CNPJ / CPF", field: "cpf_Cnpj" },
                      { title: "Código do Cadastro", field: "codigoCadastro" },
                      { title: "Status", field: "status" },
                      {
                        title: "Categoria",
                        field:
                          "setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.descricao",
                      },
                      {
                        title: "Fantasia",
                        render: (rowData) => handleColumnRazaoSocial(rowData),
                      },
                      {
                        title: "Responsável",
                        render: (rowData) => handleColumnResponsavel(rowData),
                      },
                      {
                        title: "Endereço",
                        render: (rowData) => handleColumnEndereco(rowData),
                      },
                    ]}
                    data={listProtocolos}
                    isLoading={false}
                    options={{
                      filtering: false,
                      exportButton: true,
                      table_style,
                    }}
                    actions={[
                      {
                        icon: "search",
                        tooltip: "Visualizar Registro",
                        onClick: (event, rowData) => handleView(rowData),
                      },
                    ]}
                    localization={table_translate}
                  />
                </Col>
              </Row>
            )}
          </CardBody>
        </Card>
        {protocolo != null && segmento === "Transportador" && (
          <FichaTransportador
            item={protocolo}
            history={history}
            showAcoesGestor={true}
          />
        )}
        {protocolo != null &&
          (segmento === "Grande Gerador" ||
            segmento === "Grande Gerador - PGRCC") && (
            <FichaGerador
              item={protocolo}
              history={history}
              showAcoesGestor={true}
            />
          )}
        {protocolo != null && segmento === "Destino Final" && (
          <FichaDestino
            item={protocolo}
            history={history}
            showAcoesGestor={true}
          />
        )}
      </div>
    </>
  );
}
